import { SET_PAGE_TEMPLATES_DATA } from 'js/store/page-templates/PageTemplates.actions.js';

import { parseData } from 'js/store/page-templates/PageTemplates.parser.js';

const initState = {
  allIds: [],
  byId: {},
  allUrls: [],
};

const makes = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case SET_PAGE_TEMPLATES_DATA: {
      const { allIds, byId, allUrls } = parseData(action.payload);
      nextState.allIds = allIds;
      nextState.byId = byId;
      nextState.allUrls = allUrls;
      return { ...state, ...nextState };
    }
  }
  return state;
};

export default makes;
